var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/theme/commons-archetype-light-theme.ts
import { archetypeLightTheme } from "@leagueplatform/genesis-core";

// src/theme/utils/format-theme-for-commons.ts
import {
  toPx,
  toRem,
  getNegativeSpacing,
  getFontWeightNumberByName,
  getFontWeightTokenByNumber,
  getFallbackValues
} from "@leagueplatform/genesis-core";

// src/theme/shadows.ts
var getFocusShadows = (colors) => ({
  focusOutline: `0 0 0 2px ${colors.interactive.focus.outer}`,
  focusRing: `0 0 0 2px ${colors.surface.background.primary}, 0 0 0 4px ${colors.interactive.focus.outer}`,
  dangerRing: `0 0 0 2px white, 0 0 0 4px ${colors.critical.border.default}`
});

// src/theme/utils/format-theme-for-commons.ts
var wordToNumber = {
  One: 1,
  Two: 2,
  Three: 3,
  Four: 4
};
var getMappedTypographyKey = (typographyKey) => {
  let mappedTypographyKey = typographyKey;
  Object.entries(wordToNumber).forEach(
    ([numberWord, numberValue]) => {
      const regexp = new RegExp(numberWord);
      mappedTypographyKey = mappedTypographyKey.replace(
        regexp,
        String(numberValue)
      );
    }
  );
  return mappedTypographyKey;
};
var getRemFontSizes = (themeInput) => {
  var _a;
  const fontSizes = {};
  if ((_a = themeInput == null ? void 0 : themeInput.rem) == null ? void 0 : _a.fontSizes) {
    Object.entries(themeInput.rem.fontSizes).forEach(
      ([fontSize, value]) => {
        const mappedFontSizeKey = getMappedTypographyKey(fontSize);
        fontSizes[mappedFontSizeKey] = String(value);
      }
    );
  }
  return toRem(fontSizes);
};
var getFontSizes = (themeInput) => {
  const fontSizes = {};
  if (themeInput == null ? void 0 : themeInput.typography) {
    Object.entries(themeInput.typography).forEach(
      ([typographyKey, { fontSize }]) => {
        const mappedTypographyKey = getMappedTypographyKey(typographyKey);
        fontSizes[mappedTypographyKey] = fontSize;
      }
    );
  }
  return fontSizes;
};
var defaultFontWeights = {
  bold: 700,
  semibold: 600,
  medium: 500,
  regular: 400
};
var getRemLineHeights = (themeInput) => {
  var _a;
  const lineHeights = {};
  if ((_a = themeInput == null ? void 0 : themeInput.rem) == null ? void 0 : _a.fontSizes) {
    Object.entries(themeInput.rem.lineHeights).forEach(
      ([lineHeight, value]) => {
        const mappedTypographyKey = getMappedTypographyKey(lineHeight);
        lineHeights[mappedTypographyKey] = String(value);
      }
    );
  }
  return toRem(lineHeights);
};
var getLineHeights = (themeInput) => {
  const lineHeights = {};
  if (themeInput == null ? void 0 : themeInput.typography) {
    Object.entries(themeInput.typography).forEach(
      ([typographyKey, { lineHeight }]) => {
        const mappedLineHeightKey = getMappedTypographyKey(typographyKey);
        lineHeights[mappedLineHeightKey] = lineHeight;
      }
    );
  }
  return toPx(lineHeights);
};
var getShadows = (shadows, colors) => {
  const shadowTokens = {};
  Object.entries(shadows).forEach(
    ([shadowKey, { x, y, blur, spread, color: color2 }]) => {
      shadowTokens[shadowKey] = `${x}px ${y}px ${blur}px ${spread}px ${color2}`;
    }
  );
  const focusShadows = getFocusShadows(colors);
  return __spreadValues(__spreadValues({}, shadowTokens), focusShadows);
};
var getMappedFontWeight = ({ fontWeight }) => {
  let fontWeightToken;
  if (typeof fontWeight === "string") {
    const fontWeightValue = getFontWeightNumberByName(fontWeight);
    fontWeightToken = getFontWeightTokenByNumber(fontWeightValue);
    return fontWeightToken;
  }
  fontWeightToken = getFontWeightTokenByNumber(fontWeight);
  return fontWeight;
};
var getMappedFontFamily = ({ fontFamily }, fonts) => {
  let font = fontFamily;
  Object.entries(fonts).forEach(([token, value]) => {
    if (font === value) {
      font = token;
    }
  });
  return font;
};
var mapTypographyTokenValues = (token, tokenValue, { fonts, lineHeights, fontSizes }) => __spreadProps(__spreadValues({}, tokenValue), {
  fontSize: fontSizes[token],
  lineHeight: lineHeights[token],
  fontWeight: getMappedFontWeight(tokenValue),
  fontFamily: getMappedFontFamily(tokenValue, fonts),
  textTransform: tokenValue.textCase
});
var getTypography = (theme, commonsTheme) => {
  const typography2 = {};
  Object.entries(theme.typography).forEach(([token, tokenValue]) => {
    const mappedToken = getMappedTypographyKey(token);
    typography2[token] = mapTypographyTokenValues(
      mappedToken,
      tokenValue,
      commonsTheme
    );
  });
  return typography2;
};
var formatThemeForCommons = (theme, { useRems } = {
  useRems: false
}) => {
  const resolvedTheme = getFallbackValues(theme);
  const {
    colors,
    spacing,
    borderRadii,
    fonts,
    shadows,
    fontWeights: coreFontWeights
  } = resolvedTheme;
  const space2 = __spreadValues(__spreadValues({}, spacing), getNegativeSpacing(spacing));
  const fontSizes = useRems ? getRemFontSizes(resolvedTheme) : getFontSizes(resolvedTheme);
  const lineHeights = useRems ? getRemLineHeights(resolvedTheme) : getLineHeights(resolvedTheme);
  const fontWeights = coreFontWeights != null ? coreFontWeights : defaultFontWeights;
  const commonsThemeBase = {
    colors,
    fonts,
    space: space2,
    fontSizes,
    lineHeights,
    fontWeights
  };
  return __spreadProps(__spreadValues({}, commonsThemeBase), {
    sizes: spacing,
    radii: borderRadii,
    shadows: getShadows(shadows, colors),
    typography: getTypography(theme, commonsThemeBase)
  });
};

// src/theme/breakpoints.ts
var breakpointsMap = {
  phone: 480,
  tablet: 768,
  laptop: 1024,
  desktop: 1280
};
var px = (breakpoint) => `${breakpoint}px`;
var breakpoints = Object.values(breakpointsMap).sort((a, b) => a - b).map(px);
Object.keys(breakpointsMap).forEach((key) => {
  breakpoints[key] = px(breakpointsMap[key]);
});

// src/theme/borderWidths.ts
var defaultBorderWidths = {
  none: 0,
  thin: 1,
  thick: 2,
  thicker: 4,
  outerFocus: 2,
  innerFocus: 2
};

// src/theme/globalRadii.ts
var globalRadii = {
  none: 0,
  thin: 1,
  thick: 2,
  small: 3,
  medium: 6,
  large: 9,
  extraLarge: 12,
  huge: 20,
  pill: 40,
  circle: "50%"
};

// src/theme/zIndices.ts
var zIndices = {
  default: 1,
  sticky: 100,
  dropdown: 4e3,
  tooltip: 5e3,
  modal: 8e3,
  toast: 9e3
};

// src/theme/durations.ts
var durations = {
  none: 0,
  fast: "100ms",
  base: "200ms",
  slow: "300ms"
};

// src/theme/globalTokens.ts
var GLOBAL_TOKENS = {
  breakpoints,
  borderWidths: defaultBorderWidths,
  radii: globalRadii,
  zIndices,
  durations
};

// src/utils/themeWithGlobalTokens.ts
var themeWithGlobalTokens = (_a) => {
  var _b = _a, {
    radii
  } = _b, theme = __objRest(_b, [
    "radii"
  ]);
  const completeTheme = __spreadProps(__spreadValues(__spreadValues({}, theme), GLOBAL_TOKENS), {
    radii: __spreadValues(__spreadValues({}, GLOBAL_TOKENS.radii), radii)
  });
  return completeTheme;
};

// src/theme/commons-archetype-light-theme.ts
var commonsArchetypeLightTheme = formatThemeForCommons(archetypeLightTheme);
var commonsArchetypeLightThemeWithGlobalTokens = themeWithGlobalTokens(
  commonsArchetypeLightTheme
);

// src/theme/GenesisThemeProvider.tsx
import { ThemeProvider as EmoThemeProvider } from "emotion-theming";
import { jsx } from "@emotion/core/jsx-runtime";
var GenesisThemeProvider = (_a) => {
  var _b = _a, { theme } = _b, props = __objRest(_b, ["theme"]);
  const hostAppTheme = theme;
  const completeTheme = themeWithGlobalTokens(hostAppTheme);
  return /* @__PURE__ */ jsx(EmoThemeProvider, __spreadValues({ theme: completeTheme }, props));
};

// src/theme/useTheme.ts
import { useTheme as useContextTheme } from "emotion-theming";
var useTheme = () => {
  const contextTheme = useContextTheme();
  if (!contextTheme) {
    throw new Error(
      "Could not find a theme; did you forget to wrap your code in a GenesisThemeProvider and pass in a theme?"
    );
  }
  return contextTheme;
};

// src/utils/genesisStyled.ts
import { default as default2 } from "@emotion/styled";

// src/utils/logical-css-properties-values.ts
var logicalProperties = {
  blockSize: "sizes",
  borderBlock: "borders",
  borderBlockColor: "colors",
  borderBlockEnd: "borders",
  borderBlockEndColor: "colors",
  borderBlockEndStyle: "borderStyles",
  borderBlockEndWidth: "borderWidths",
  borderBlockStart: "borders",
  borderBlockStartColor: "colors",
  borderBlockStartStyle: "borderStyles",
  borderBlockStartWidth: "borderWidths",
  borderBlockStyle: "borderStyles",
  borderBlockWidth: "borderWidths",
  borderEndEndRadius: "radii",
  borderEndStartRadius: "radii",
  borderInline: "borders",
  borderInlineColor: "colors",
  borderInlineEnd: "borders",
  borderInlineEndColor: "colors",
  borderInlineEndStyle: "borderStyles",
  borderInlineEndWidth: "borderWidths",
  borderInlineStart: "borders",
  borderInlineStartColor: "colors",
  borderInlineStartStyle: "borderStyles",
  borderInlineStartWidth: "borderWidths",
  borderInlineStyle: "borderStyles",
  borderInlineWidth: "borderWidths",
  borderStartEndRadius: "radii",
  borderStartStartRadius: "radii",
  inlineSize: "sizes",
  inset: "space",
  insetBlock: "space",
  insetBlockEnd: "space",
  insetBlockStart: "space",
  insetInline: "space",
  insetInlineEnd: "space",
  insetInlineStart: "space",
  marginBlock: "space",
  marginBlockEnd: "space",
  marginBlockStart: "space",
  marginInline: "space",
  marginInlineEnd: "space",
  marginInlineStart: "space",
  maxBlockSize: "sizes",
  maxInlineSize: "sizes",
  minBlockSize: "sizes",
  minInlineSize: "sizes",
  paddingBlock: "space",
  paddingBlockEnd: "space",
  paddingBlockStart: "space",
  paddingInline: "space",
  paddingInlineEnd: "space",
  paddingInlineStart: "space"
};
var logicalSystemProps = Object.entries(logicalProperties).reduce(
  (acc, [property, scale]) => {
    acc[property] = {
      property,
      scale
    };
    return acc;
  },
  {}
);

// src/utils/css.js
var get = (obj, key, def, p, undef) => {
  key = key && key.split ? key.split(".") : [key];
  for (p = 0; p < key.length; p++) {
    obj = obj ? obj[key[p]] : undef;
  }
  return obj === undef ? def : obj;
};
var defaultBreakpoints = [40, 52, 64].map((n) => `${n}em`);
var defaultTheme = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
  fontSizes: [12, 14, 16, 20, 24, 32, 48, 64, 72]
};
var aliases = {
  bg: "backgroundColor",
  m: "margin",
  mt: "marginTop",
  mr: "marginRight",
  mb: "marginBottom",
  ml: "marginLeft",
  mx: "marginX",
  my: "marginY",
  p: "padding",
  pt: "paddingTop",
  pr: "paddingRight",
  pb: "paddingBottom",
  pl: "paddingLeft",
  px: "paddingX",
  py: "paddingY"
};
var multiples = {
  marginX: ["marginLeft", "marginRight"],
  marginY: ["marginTop", "marginBottom"],
  paddingX: ["paddingLeft", "paddingRight"],
  paddingY: ["paddingTop", "paddingBottom"],
  size: ["width", "height"]
};
var scales = __spreadValues({
  color: "colors",
  backgroundColor: "colors",
  borderColor: "colors",
  margin: "space",
  marginTop: "space",
  marginRight: "space",
  marginBottom: "space",
  marginLeft: "space",
  marginX: "space",
  marginY: "space",
  padding: "space",
  paddingTop: "space",
  paddingRight: "space",
  paddingBottom: "space",
  paddingLeft: "space",
  paddingX: "space",
  paddingY: "space",
  top: "space",
  right: "space",
  bottom: "space",
  left: "space",
  gridGap: "space",
  gridColumnGap: "space",
  gridRowGap: "space",
  gap: "space",
  columnGap: "space",
  rowGap: "space",
  fontFamily: "fonts",
  fontSize: "fontSizes",
  fontWeight: "fontWeights",
  lineHeight: "lineHeights",
  letterSpacing: "letterSpacings",
  border: "borders",
  borderTop: "borders",
  borderRight: "borders",
  borderBottom: "borders",
  borderLeft: "borders",
  borderWidth: "borderWidths",
  borderStyle: "borderStyles",
  borderRadius: "radii",
  borderTopRightRadius: "radii",
  borderTopLeftRadius: "radii",
  borderBottomRightRadius: "radii",
  borderBottomLeftRadius: "radii",
  borderTopWidth: "borderWidths",
  borderTopColor: "colors",
  borderTopStyle: "borderStyles",
  borderBottomWidth: "borderWidths",
  borderBottomColor: "colors",
  borderBottomStyle: "borderStyles",
  borderLeftWidth: "borderWidths",
  borderLeftColor: "colors",
  borderLeftStyle: "borderStyles",
  borderRightWidth: "borderWidths",
  borderRightColor: "colors",
  borderRightStyle: "borderStyles",
  outlineColor: "colors",
  boxShadow: "shadows",
  textShadow: "shadows",
  zIndex: "zIndices",
  width: "sizes",
  minWidth: "sizes",
  maxWidth: "sizes",
  height: "sizes",
  minHeight: "sizes",
  maxHeight: "sizes",
  flexBasis: "sizes",
  size: "sizes",
  // svg
  fill: "colors",
  stroke: "colors"
}, logicalProperties);
var positiveOrNegative = (scale, value) => {
  if (typeof value !== "number" || value >= 0) {
    return get(scale, value, value);
  }
  const absolute = Math.abs(value);
  const n = get(scale, absolute, absolute);
  if (typeof n === "string")
    return `-${n}`;
  return n * -1;
};
var transforms = [
  "margin",
  "marginTop",
  "marginRight",
  "marginBottom",
  "marginLeft",
  "marginX",
  "marginY",
  "top",
  "bottom",
  "left",
  "right"
].reduce(
  (acc, curr) => __spreadProps(__spreadValues({}, acc), {
    [curr]: positiveOrNegative
  }),
  {}
);
var responsive = (styles) => (theme) => {
  const next = {};
  const breakpoints2 = get(theme, "breakpoints", defaultBreakpoints);
  const mediaQueries = [
    null,
    ...breakpoints2.map((n) => `@media screen and (min-width: ${n})`)
  ];
  for (const key in styles) {
    const value = typeof styles[key] === "function" ? styles[key](theme) : styles[key];
    if (value == null)
      continue;
    if (!Array.isArray(value)) {
      next[key] = value;
      continue;
    }
    for (let i = 0; i < value.slice(0, mediaQueries.length).length; i++) {
      const media = mediaQueries[i];
      if (!media) {
        next[key] = value[i];
        continue;
      }
      next[media] = next[media] || {};
      if (value[i] == null)
        continue;
      next[media][key] = value[i];
    }
  }
  return next;
};
var css = (args) => (props = {}) => {
  const theme = __spreadValues(__spreadValues({}, defaultTheme), props.theme || props);
  let result = {};
  const obj = typeof args === "function" ? args(theme) : args;
  const styles = responsive(obj)(theme);
  for (const key in styles) {
    const x = styles[key];
    const val = typeof x === "function" ? x(theme) : x;
    if (key === "variant") {
      const variant = css(get(theme, val))(theme);
      result = __spreadValues(__spreadValues({}, result), variant);
      continue;
    }
    if (val && typeof val === "object") {
      result[key] = css(val)(theme);
      continue;
    }
    const prop = get(aliases, key, key);
    const scaleName = get(scales, prop);
    const scale = get(theme, scaleName, get(theme, prop, {}));
    const transform = get(transforms, prop, get);
    const value = transform(scale, val, val);
    if (multiples[prop]) {
      const dirs = multiples[prop];
      for (let i = 0; i < dirs.length; i++) {
        result[dirs[i]] = value;
      }
    } else {
      result[prop] = value;
    }
  }
  return result;
};
var css_default = css;

// src/Box/Box.tsx
import { forwardRef } from "react";
import styled from "@emotion/styled";
import _shouldForwardProp from "@styled-system/should-forward-prop";
import {
  space,
  color,
  border,
  shadow,
  position,
  background,
  layout,
  flexbox,
  typography,
  system,
  compose
} from "styled-system";
import {
  pseudolocalize,
  shouldPseudolocalize
} from "@leagueplatform/genesis-core";
import { jsx as jsx2 } from "@emotion/core/jsx-runtime";
var outlineSystemProps = {
  outline: true,
  outlineColor: {
    property: "outlineColor",
    scale: "colors"
  },
  outlineStyle: {
    property: "outlineStyle",
    scale: "borderStyles"
  },
  outlineWidth: {
    property: "outlineWidth",
    scale: "borderWidths"
  }
};
var customSystemProps = system(__spreadProps(__spreadValues(__spreadValues({}, outlineSystemProps), logicalSystemProps), {
  typography: {
    property: "typography",
    scale: "typography"
  },
  transitionDuration: {
    property: "transitionDuration",
    scale: "durations"
  },
  cursor: true,
  textDecoration: true,
  textTransform: true,
  transition: true,
  transform: true
}));
var styleFunctions = [
  background,
  border,
  color,
  flexbox,
  layout,
  position,
  shadow,
  space,
  typography,
  customSystemProps
];
var styleProps = compose(...styleFunctions);
var pseudoStateStyleProps = compose(
  ...styleFunctions.filter((prop) => ![typography].includes(prop))
);
var shouldForwardProp = (prop) => {
  switch (prop) {
    case "textDecoration":
      return false;
    default:
      return _shouldForwardProp(prop);
  }
};
var Base = styled("div", {
  shouldForwardProp
})({ boxSizing: "border-box" }, (props) => __spreadProps(__spreadValues({}, styleProps(props)), {
  "&:visited": pseudoStateStyleProps(__spreadValues({
    theme: props.theme
  }, props.visitedStyle)),
  "&:focus": pseudoStateStyleProps(__spreadValues({
    theme: props.theme
  }, props.focusStyle)),
  "&:focus-visible": pseudoStateStyleProps(__spreadValues({
    theme: props.theme
  }, props.focusStyle)),
  "&:hover": pseudoStateStyleProps(__spreadValues({
    theme: props.theme
  }, props.hoverStyle)),
  "&:active": pseudoStateStyleProps(__spreadValues({
    theme: props.theme
  }, props.activeStyle)),
  "&:disabled": pseudoStateStyleProps(__spreadValues({
    theme: props.theme
  }, props.disabledStyle))
}));
function hasBorderWidth(props) {
  return Object.keys(props).find((prop) => prop.match(/border.*Width/));
}
function borderValue(props, prop, defaultValue) {
  const value = props[prop];
  if (value) {
    return value;
  }
  return hasBorderWidth(props) ? defaultValue : void 0;
}
var Box = forwardRef(
  (_a, ref) => {
    var _b = _a, {
      fontSize,
      lineHeight = fontSize,
      className,
      border: border2,
      borderX,
      borderY,
      borderTop,
      borderBottom,
      borderInlineEnd,
      borderInlineStart
    } = _b, props = __objRest(_b, [
      "fontSize",
      "lineHeight",
      "className",
      "border",
      "borderX",
      "borderY",
      "borderTop",
      "borderBottom",
      "borderInlineEnd",
      "borderInlineStart"
    ]);
    const decreaseBorderShorthandSpecificity = {
      border: border2,
      borderX,
      borderY,
      borderTop,
      borderBottom,
      borderInlineEnd,
      borderInlineStart
    };
    const _a2 = props, { children } = _a2, restOfProps = __objRest(_a2, ["children"]);
    return /* @__PURE__ */ jsx2(
      Base,
      __spreadProps(__spreadValues(__spreadProps(__spreadValues({
        ref,
        margin: "none",
        padding: "none",
        fontFamily: "body",
        fontSize,
        lineHeight
      }, decreaseBorderShorthandSpecificity), {
        borderColor: borderValue(
          props,
          "borderColor",
          "onSurface.border.subdued"
        ),
        borderStyle: borderValue(props, "borderStyle", "solid"),
        borderWidth: borderValue(props, "borderWidth", 0),
        className: ["genesis", className].filter(Boolean).join(" ")
      }), restOfProps), {
        children: shouldPseudolocalize ? pseudolocalize(children) : children
      })
    );
  }
);
Box.displayName = "Box";

// src/utils/visuallyHidden.tsx
var visuallyHidden = Object.freeze({
  ":not(:focus):not(:active)": {
    position: "absolute",
    height: 1,
    width: 1,
    overflow: "hidden",
    clip: "rect(1px, 1px, 1px, 1px)",
    whiteSpace: "nowrap"
  }
});
var VisuallyHidden = default2(Box)(css_default(visuallyHidden));
VisuallyHidden.defaultProps = { as: "span" };

// src/Spinner/Spinner.tsx
import { forwardRef as forwardRef3 } from "react";

// src/Flex/Flex.tsx
import { forwardRef as forwardRef2 } from "react";
import styled2 from "@emotion/styled";
import { flexbox as flexbox2, system as system2, compose as compose2 } from "styled-system";
import { jsx as jsx3 } from "@emotion/core/jsx-runtime";
var FlexBase = styled2(
  Box
)`
  ${compose2(
  flexbox2,
  system2({
    display: {
      property: "display",
      defaultScale: {
        flex: "flex",
        block: "flex",
        "inline-flex": "inline-flex",
        "inline-block": "inline-flex",
        inline: "inline-flex"
      },
      transform: (value, scale) => {
        var _a;
        return (_a = scale == null ? void 0 : scale[value]) != null ? _a : "flex";
      }
    },
    gap: {
      property: "gap",
      scale: "space"
    },
    columnGap: {
      property: "columnGap",
      scale: "space"
    },
    rowGap: {
      property: "rowGap",
      scale: "space"
    }
  })
)}
`;
var Flex = forwardRef2(
  (_a, ref) => {
    var _b = _a, { display = "flex" } = _b, props = __objRest(_b, ["display"]);
    return /* @__PURE__ */ jsx3(FlexBase, __spreadValues({ ref, display }, props));
  }
);
Flex.displayName = "Flex";

// src/Spinner/circle.component.tsx
import { jsx as jsx4, jsxs } from "@emotion/core/jsx-runtime";
function Circle({ className }) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      className,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      children: [
        /* @__PURE__ */ jsx4("symbol", { id: "circle", strokeLinecap: "round", children: /* @__PURE__ */ jsx4("circle", { cx: "12", cy: "12", r: "10", stroke: "currentcolor" }) }),
        /* @__PURE__ */ jsx4("use", { xlinkHref: "#circle" })
      ]
    }
  );
}

// src/Spinner/Spinner.tsx
import { Fragment, jsx as jsx5, jsxs as jsxs2 } from "@emotion/core/jsx-runtime";
var StyledCircle = default2(Circle)`
  fill: transparent;
  height: 24px;
  stroke-width: 2;
  stroke-dasharray: 40;
  stroke-dashoffset: 80;
  animation: stroke 2s linear infinite forwards,
    rotate 1s linear infinite forwards;
  @keyframes stroke {
    to {
      stroke-dashoffset: 0;
    }
  }
  @keyframes rotate {
    to {
      transform: rotate(360deg);
    }
  }
`;
var Span = forwardRef3((props, ref) => /* @__PURE__ */ jsx5(Box, __spreadValues({ as: "span", ref }, props)));
Span.displayName = "Span";
var SpinnerPositioner = default2(Flex)`
  position: absolute;
  top: 50%;
  inset-inline-start: 50%;
  transform: translate(-50%, -50%);
  align-items: center;
  justify-content: center;
`;
SpinnerPositioner.defaultProps = { as: "span" };
var Spinner = forwardRef3(
  (_a, ref) => {
    var _b = _a, { children, isLoading, renderLoadingText = true } = _b, props = __objRest(_b, ["children", "isLoading", "renderLoadingText"]);
    return /* @__PURE__ */ jsxs2(Span, __spreadProps(__spreadValues({ display: "block", position: "relative", ref }, props), { children: [
      isLoading && /* @__PURE__ */ jsxs2(Fragment, { children: [
        /* @__PURE__ */ jsx5(SpinnerPositioner, { "aria-hidden": "true", children: /* @__PURE__ */ jsx5(StyledCircle, {}) }),
        renderLoadingText && /* @__PURE__ */ jsx5(VisuallyHidden, { children: "Loading." })
      ] }),
      /* @__PURE__ */ jsx5(Span, { opacity: isLoading && "0", children })
    ] }));
  }
);
Spinner.displayName = "Spinner";

// src/Typography/Text/Text.tsx
import { forwardRef as forwardRef4 } from "react";
import styled3 from "@emotion/styled";
import { jsx as jsx6 } from "@emotion/core/jsx-runtime";
var TextBase = styled3(Box)``;
var Text = forwardRef4(
  (_a, ref) => {
    var _b = _a, { typography: typographyToken } = _b, props = __objRest(_b, ["typography"]);
    const { typography: typography2 } = useTheme();
    const typographyStyles = typographyToken && typography2[typographyToken];
    return /* @__PURE__ */ jsx6(TextBase, __spreadValues(__spreadValues({ as: "p", ref }, typographyStyles), props));
  }
);
Text.displayName = "Text";

// src/Typography/BodyOne/BodyOne.tsx
import { forwardRef as forwardRef5 } from "react";
import { jsx as jsx7 } from "@emotion/core/jsx-runtime";
var BodyOne = forwardRef5(
  (props, ref) => /* @__PURE__ */ jsx7(
    Text,
    __spreadValues({
      as: "p",
      color: "onSurface.text.primary",
      typography: "bodyOne",
      ref
    }, props)
  )
);
BodyOne.displayName = "BodyOne";

// src/Typography/BodyTwo/BodyTwo.tsx
import { forwardRef as forwardRef6 } from "react";
import { jsx as jsx8 } from "@emotion/core/jsx-runtime";
var BodyTwo = forwardRef6(
  (props, ref) => /* @__PURE__ */ jsx8(
    Text,
    __spreadValues({
      as: "p",
      color: "onSurface.text.primary",
      typography: "bodyTwo",
      ref
    }, props)
  )
);
BodyTwo.displayName = "BodyTwo";

// src/Typography/BodyOneSecondary/BodyOneSecondary.tsx
import { forwardRef as forwardRef7 } from "react";
import { jsx as jsx9 } from "@emotion/core/jsx-runtime";
var BodyOneSecondary = forwardRef7(
  (props, ref) => /* @__PURE__ */ jsx9(
    Text,
    __spreadValues({
      as: "p",
      color: "onSurface.text.subdued",
      typography: "bodyOneSecondary",
      ref
    }, props)
  )
);
BodyOneSecondary.displayName = "BodyOneSecondary";

// src/Typography/BodyTwoSecondary/BodyTwoSecondary.tsx
import { forwardRef as forwardRef8 } from "react";
import { jsx as jsx10 } from "@emotion/core/jsx-runtime";
var BodyTwoSecondary = forwardRef8(
  (props, ref) => /* @__PURE__ */ jsx10(
    Text,
    __spreadValues({
      as: "p",
      color: "onSurface.text.subdued",
      typography: "bodyTwoSecondary",
      ref
    }, props)
  )
);
BodyTwoSecondary.displayName = "BodyTwoSecondary";

// src/Typography/Caption/Caption.tsx
import { forwardRef as forwardRef9 } from "react";
import { jsx as jsx11 } from "@emotion/core/jsx-runtime";
var Caption = forwardRef9(
  (props, ref) => /* @__PURE__ */ jsx11(
    Text,
    __spreadValues({
      as: "p",
      color: "onSurface.text.primary",
      typography: "caption",
      ref
    }, props)
  )
);
Caption.displayName = "Caption";

// src/Typography/HeadingOne/HeadingOne.tsx
import { forwardRef as forwardRef10 } from "react";
import { jsx as jsx12 } from "@emotion/core/jsx-runtime";
var HeadingOne = forwardRef10(
  (props, ref) => /* @__PURE__ */ jsx12(
    Text,
    __spreadValues({
      as: "h1",
      color: "onSurface.text.primary",
      typography: "headingOne",
      ref
    }, props)
  )
);
HeadingOne.displayName = "HeadingOne";

// src/Typography/HeadingTwo/HeadingTwo.tsx
import { forwardRef as forwardRef11 } from "react";
import { jsx as jsx13 } from "@emotion/core/jsx-runtime";
var HeadingTwo = forwardRef11(
  (props, ref) => /* @__PURE__ */ jsx13(
    Text,
    __spreadValues({
      as: "h2",
      color: "onSurface.text.primary",
      typography: "headingTwo",
      ref
    }, props)
  )
);
HeadingTwo.displayName = "HeadingTwo";

// src/Typography/HeadingThree/HeadingThree.tsx
import { forwardRef as forwardRef12 } from "react";
import { jsx as jsx14 } from "@emotion/core/jsx-runtime";
var HeadingThree = forwardRef12(
  (props, ref) => /* @__PURE__ */ jsx14(
    Text,
    __spreadValues({
      as: "h3",
      color: "onSurface.text.primary",
      typography: "headingThree",
      ref
    }, props)
  )
);
HeadingThree.displayName = "HeadingThree";

// src/Typography/HeadingFour/HeadingFour.tsx
import { forwardRef as forwardRef13 } from "react";
import { jsx as jsx15 } from "@emotion/core/jsx-runtime";
var HeadingFour = forwardRef13(
  (props, ref) => /* @__PURE__ */ jsx15(
    Text,
    __spreadValues({
      as: "h4",
      color: "onSurface.text.primary",
      typography: "headingFour",
      ref
    }, props)
  )
);
HeadingFour.displayName = "HeadingFour";

// src/Typography/SubtitleOne/SubtitleOne.tsx
import { forwardRef as forwardRef14 } from "react";
import { jsx as jsx16 } from "@emotion/core/jsx-runtime";
var SubtitleOne = forwardRef14(
  (props, ref) => /* @__PURE__ */ jsx16(
    Text,
    __spreadValues({
      as: "h5",
      color: "onSurface.text.primary",
      typography: "subtitleOne",
      ref
    }, props)
  )
);
SubtitleOne.displayName = "SubtitleOne";

// src/Typography/SubtitleTwo/SubtitleTwo.tsx
import { forwardRef as forwardRef15 } from "react";
import { jsx as jsx17 } from "@emotion/core/jsx-runtime";
var SubtitleTwo = forwardRef15(
  (props, ref) => /* @__PURE__ */ jsx17(
    Text,
    __spreadValues({
      as: "h5",
      color: "onSurface.text.primary",
      typography: "subtitleTwo",
      ref
    }, props)
  )
);
SubtitleTwo.displayName = "SubtitleTwo";

// src/Typography/Overline/Overline.tsx
import { forwardRef as forwardRef16 } from "react";
import { jsx as jsx18 } from "@emotion/core/jsx-runtime";
var Overline = forwardRef16(
  (props, ref) => /* @__PURE__ */ jsx18(
    Text,
    __spreadValues({
      as: "h6",
      color: "onSurface.text.primary",
      typography: "overline",
      ref
    }, props)
  )
);
Overline.displayName = "Overline";

// src/Typography/ErrorMessage/ErrorMessage.tsx
import { forwardRef as forwardRef17 } from "react";
import { jsx as jsx19 } from "@emotion/core/jsx-runtime";
var ErrorMessage = forwardRef17(
  (props, ref) => /* @__PURE__ */ jsx19(
    Text,
    __spreadValues({
      color: "onSurface.text.critical",
      fontSize: "body2",
      margin: "none",
      padding: "none",
      ref
    }, props)
  )
);
ErrorMessage.displayName = "ErrorMessage";

// src/Label/Label.tsx
import { forwardRef as forwardRef18 } from "react";
import { jsx as jsx20 } from "@emotion/core/jsx-runtime";
var labelProps = ({ disabled: disabled2 }) => ({
  as: "label",
  fontSize: "body1",
  css: css_default({ cursor: disabled2 ? "default" : "pointer" })
});
var Label = forwardRef18(
  (_a, ref) => {
    var _b = _a, { children, display = "block" } = _b, props = __objRest(_b, ["children", "display"]);
    return display === "flex" ? /* @__PURE__ */ jsx20(Flex, __spreadProps(__spreadValues(__spreadValues({ alignItems: "center", ref }, labelProps(props)), props), { children })) : /* @__PURE__ */ jsx20(Box, __spreadProps(__spreadValues(__spreadValues({ display, ref }, labelProps(props)), props), { children }));
  }
);
Label.displayName = "Label";

// src/Label/LabelText/LabelText.tsx
import { forwardRef as forwardRef19 } from "react";
import { jsx as jsx21 } from "@emotion/core/jsx-runtime";
var LabelText = forwardRef19(
  (props, ref) => /* @__PURE__ */ jsx21(
    Text,
    __spreadValues({
      as: "span",
      display: "block",
      color: "onSurface.text.subdued",
      typography: "label",
      ref
    }, props)
  )
);
LabelText.displayName = "LabelText";

// src/Label/ChoiceText/ChoiceText.tsx
import { forwardRef as forwardRef20 } from "react";
import { jsx as jsx22 } from "@emotion/core/jsx-runtime";
var disabledStyle = { color: "onSurface.text.subdued" };
var disabled = ({ disabled: isDisabled }) => isDisabled ? disabledStyle : {};
var ChoiceText = forwardRef20(
  (props, ref) => /* @__PURE__ */ jsx22(
    Text,
    __spreadValues(__spreadValues({
      as: "span",
      color: "onSurface.text.primary",
      fontSize: "body1",
      ref,
      css: css_default({
        "input:disabled ~ &, & ~ input:disabled": disabledStyle
      })
    }, disabled(props)), props)
  )
);
ChoiceText.displayName = "ChoiceText";

// src/Input/Input.ts
var visuallyHiddenInputStyles = {
  position: "absolute",
  opacity: 0,
  zIndex: -1,
  width: 1,
  height: 1,
  overflow: "hidden"
};

// src/Input/TextInput/TextInput.tsx
import { forwardRef as forwardRef22 } from "react";

// src/Input/TextInputBase/TextInputBase.tsx
import { forwardRef as forwardRef21 } from "react";

// src/utils/trueOrUndefined.ts
function trueOrUndefined(prop) {
  return Boolean(prop) || void 0;
}

// src/Input/TextInputBase/TextInputBase.tsx
import { jsx as jsx23 } from "@emotion/core/jsx-runtime";
var TextInputBase = forwardRef21(
  (_a, ref) => {
    var _b = _a, { error, className } = _b, props = __objRest(_b, ["error", "className"]);
    return /* @__PURE__ */ jsx23(
      Box,
      {
        className: "Genesis-TextInputBase-Container",
        as: "div",
        css: css_default({
          lineHeight: 0,
          position: "relative",
          "::before": {
            content: '""',
            position: "absolute",
            top: "-2px",
            insetInlineStart: "-2px",
            insetInlineEnd: "-2px",
            bottom: "-2px",
            borderRadius: "small",
            pointerEvents: "none"
          },
          ":focus-within::before": {
            boxShadow: "focusOutline"
          }
        }),
        children: /* @__PURE__ */ jsx23(
          Box,
          __spreadValues({
            className: `Genesis-TextInputBase-Input ${className}`,
            as: "input",
            ref,
            color: "onSurface.text.primary",
            paddingY: "threeQuarters",
            paddingX: "one",
            borderRadius: "small",
            borderColor: error ? "interactive.border.critical.default" : "interactive.border.default",
            borderStyle: "solid",
            borderWidth: "thin",
            fontSize: "body1",
            width: "100%",
            "aria-invalid": trueOrUndefined(Boolean(error)),
            focusStyle: {
              outline: "0"
            },
            hoverStyle: {
              borderColor: "interactive.border.hovered"
            },
            disabledStyle: {
              backgroundColor: "interactive.background.disabled",
              borderColor: "interactive.border.disabled",
              color: "interactive.action.subdued"
            },
            css: css_default({
              "::placeholder": {
                color: "interactive.action.subdued"
              }
            })
          }, props)
        )
      }
    );
  }
);
TextInputBase.displayName = "TextInputBase";

// src/Input/TextInput/TextInput.tsx
import { jsx as jsx24 } from "@emotion/core/jsx-runtime";
var TextInput = forwardRef22(
  (props, ref) => /* @__PURE__ */ jsx24(
    TextInputBase,
    __spreadValues({
      ref,
      height: "three",
      type: "text",
      css: css_default({
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        overflow: "hidden"
      })
    }, props)
  )
);
TextInput.displayName = "TextInput";

// src/Input/Checkbox/Checkbox.tsx
import { forwardRef as forwardRef23 } from "react";

// src/utils/propFilters.ts
import htmlElementAttributes from "react-html-attributes";
import propTypes from "@styled-system/prop-types";
var stylePropTypes = __spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues({}, propTypes.space), propTypes.color), propTypes.colourStyle), propTypes.typography), propTypes.layout), propTypes.flexbox), propTypes.background), propTypes.border), propTypes.position), propTypes.shadow);
var stylePropKeys = Object.keys(stylePropTypes);
var globalHTMLAttrsKeys = [
  "accessKey",
  "autoCapitalize",
  "className",
  "contentEditable",
  "dir",
  "draggable",
  "hidden",
  "id",
  "inputMode",
  "itemProp",
  "itemScope",
  "itemType",
  "itemRef",
  "itemID",
  "lang",
  "part",
  "slot",
  "style",
  "tabIndex",
  "title"
];
var dataAttrRegex = /^data-/;
var inputPropKeys = [
  ...htmlElementAttributes.input,
  "readOnly",
  "onBlur",
  "onFocus"
].filter((key) => !["width", "height"].includes(key));
var pick = (predicate) => function pick2(props) {
  return Object.keys(props).reduce(
    (result, prop) => predicate(prop) ? __spreadProps(__spreadValues({}, result), { [prop]: props[prop] }) : result,
    {}
  );
};
var negate = (predicate) => function negate2(prop) {
  return !predicate(prop);
};
var pickStyleProps = pick((prop) => stylePropKeys.includes(prop));
var omitStyleProps = pick((prop) => !stylePropKeys.includes(prop));
var pickGlobalHTMLProps = pick(
  (prop) => dataAttrRegex.test(prop) || globalHTMLAttrsKeys.includes(prop)
);
var pickInputProps = pick((prop) => inputPropKeys.includes(prop));
var omitInputProps = pick((prop) => !inputPropKeys.includes(prop));
var layoutPropRegex = new RegExp(
  [
    // LAYOUT https://styled-system.com/api/#layout
    /^display$/,
    /^width$/,
    /^height$/,
    /^minWidth$/,
    /^minHeight$/,
    /^maxWidth$/,
    /^maxHeight$/,
    /^size$/,
    /^verticalAlign$/,
    /^overflow$/,
    /^overflowX$/,
    /^overflowY$/,
    // POSITION https://styled-system.com/api/#position
    /^position$/,
    /^top$/,
    /^left$/,
    /^bottom$/,
    /^right$/,
    // MARGINS https://styled-system.com/api/#space
    /^margin/,
    // FLEXBOX https://styled-system.com/api/#flexbox
    /^flex/,
    /^align/,
    /^justify/,
    /^order$/
  ].map((re) => re.source).join("|")
);
var isLayoutProp = (prop) => layoutPropRegex.test(prop);
var pickLayoutProps = pick(isLayoutProp);
var omitLayoutProps = pick(negate(isLayoutProp));

// src/Input/Checkbox/Checkmark.tsx
import { jsx as jsx25 } from "@emotion/core/jsx-runtime";
var Checkmark = (_a) => {
  var _b = _a, { disabled: disabled2, size = 14 } = _b, props = __objRest(_b, ["disabled", "size"]);
  return /* @__PURE__ */ jsx25(
    "svg",
    __spreadProps(__spreadValues({
      xmlns: "http://www.w3.org/2000/svg",
      width: size,
      height: size,
      viewBox: `0 0 ${size} ${size}`,
      fill: disabled2 ? "#949494" : "#FFFFFF",
      fillRule: "evenodd",
      clipRule: "evenodd"
    }, props), {
      children: /* @__PURE__ */ jsx25("path", { d: "M5.70508 12C5.1979 12 4.7156 11.8244 4.30798 11.4918C4.22086 11.4209 4.1384 11.3433 4.06217 11.2606L0.342274 7.22566C0.121352 6.98762 0 6.66854 0 6.3309C0 5.99325 0.121352 5.67417 0.340718 5.43613C0.56164 5.1964 0.854129 5.06472 1.16529 5.06472C1.47645 5.06472 1.77049 5.1964 1.98986 5.43613L5.70664 9.46764L11.9002 0.506472C12.1196 0.189083 12.4697 0 12.8337 0C13.0873 0 13.3285 0.0877884 13.5323 0.251548C14.0488 0.671919 14.153 1.46708 13.7672 2.02589L7.57359 10.9871C7.19864 11.5273 6.65256 11.8784 6.03647 11.9747C5.92601 11.9916 5.81554 12 5.70508 12Z" })
    })
  );
};

// src/Input/Checkbox/Checkbox.tsx
import { jsx as jsx26, jsxs as jsxs3 } from "@emotion/core/jsx-runtime";
var CheckboxIcon = (props) => /* @__PURE__ */ jsx26(
  Flex,
  __spreadValues({
    "data-testid": "genesis-checkbox-input-icon",
    "aria-hidden": "true",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "interactive.icon.default",
    borderColor: "currentcolor",
    borderStyle: "solid",
    borderWidth: "thin",
    borderRadius: "small",
    position: "relative",
    color: "interactive.border.default",
    size: "oneAndHalf",
    transitionProperty: "all",
    transitionDuration: "base",
    css: css_default({
      "input ~ &, input ~ &:after": {
        transitionDuration: "base",
        transitionProperty: "all",
        transitionTimingFunction: "cubic-bezier(.17, .67, .83, .67)"
      },
      "input ~ &::before": {
        content: '""',
        position: "absolute",
        top: "-2px",
        insetInlineStart: "-2px",
        insetInlineEnd: "-2px",
        bottom: "-2px",
        borderRadius: "small"
      },
      "input ~ & > svg": {
        display: "none"
      },
      "input ~ &:after": {
        backgroundColor: "interactive.action.primary"
      },
      "input:checked ~ &, input:not(checked) ~ &:hover": {
        color: "interactive.action.primary"
      },
      "input:focus ~ &, input:focus:not(checked) ~ &": {
        borderColor: "currentcolor"
      },
      "input:focus ~ &::before, input:focus:not(checked) ~ &::before": {
        boxShadow: "focusOutline"
      },
      "input:checked ~ &": {
        backgroundColor: "currentcolor"
      },
      "input:checked ~ & > svg": {
        display: "block"
      },
      "input:disabled ~ &, input:checked:disabled ~ &, input:checked:disabled ~ &:after": {
        backgroundColor: "interactive.background.disabled",
        color: "interactive.border.disabled",
        pointerEvents: "none"
      }
    })
  }, props)
);
var Checkbox = forwardRef23(
  function Checkbox2(_a, ref) {
    var _b = _a, { checked, disabled: disabled2, defaultChecked, error } = _b, props = __objRest(_b, ["checked", "disabled", "defaultChecked", "error"]);
    const propsForCheckboxInput = __spreadValues(__spreadValues({}, pickInputProps(props)), pickGlobalHTMLProps(props));
    const propsForInputContainer = __spreadProps(__spreadValues({}, pickLayoutProps(props)), {
      // an onClick handler is passed to the Checkbox component in apps/league-b2b/src/apps/employer-experience/pages/EmployerDetails/Payroll/rate-sheet-extract/rate-sheet-extract.view.js
      onClick: props.onContainerClick
    });
    const styleProps2 = pickStyleProps(props);
    const propsForCheckboxIcon = omitLayoutProps(styleProps2);
    return /* @__PURE__ */ jsxs3(Box, __spreadProps(__spreadValues({}, propsForInputContainer), { children: [
      /* @__PURE__ */ jsx26(
        Box,
        __spreadValues({
          "data-testid": "genesis-checkbox-input",
          as: "input",
          ref,
          type: "checkbox",
          role: "checkbox",
          disabled: disabled2,
          checked,
          defaultChecked,
          "aria-checked": checked,
          "aria-invalid": trueOrUndefined(Boolean(error)),
          css: css_default(visuallyHiddenInputStyles)
        }, propsForCheckboxInput)
      ),
      /* @__PURE__ */ jsx26(
        CheckboxIcon,
        __spreadProps(__spreadValues(__spreadValues({}, !!error && {
          color: "interactive.border.critical.default"
        }), propsForCheckboxIcon), {
          children: /* @__PURE__ */ jsx26(Checkmark, { disabled: disabled2 })
        })
      )
    ] }));
  }
);
Checkbox.displayName = "Checkbox";

// src/Input/Radio/Radio.tsx
import { forwardRef as forwardRef24 } from "react";
import { jsx as jsx27, jsxs as jsxs4 } from "@emotion/core/jsx-runtime";
var RadioIcon = (props) => /* @__PURE__ */ jsx27(
  Box,
  __spreadProps(__spreadValues({}, props), {
    css: css_default({
      position: "relative",
      "input ~ &, input ~ &:after": {
        transitionProperty: "all",
        transitionTimingFunction: "cubic-bezier(.17, .67, .83, .67)"
      },
      "input ~ &": {
        backgroundColor: "white",
        borderColor: "currentcolor",
        borderStyle: "solid",
        borderWidth: "thin",
        position: "relative",
        height: "oneAndHalf",
        width: "oneAndHalf",
        borderRadius: "circle"
      },
      "input ~ &::before": {
        content: '""',
        position: "absolute",
        top: "-2px",
        insetInlineStart: "-2px",
        insetInlineEnd: "-2px",
        bottom: "-2px",
        borderRadius: "circle"
      },
      "input ~ &:after": {
        content: '""',
        width: 0,
        height: 0,
        backgroundColor: "currentcolor",
        position: "absolute",
        top: "50%",
        insetInlineStart: "50%",
        transform: "translate(-50%, -50%)",
        transformOrigin: "50%",
        borderRadius: "circle"
      },
      "input:checked ~ &, input:not(checked) ~ &:hover": {
        color: "interactive.border.hovered"
      },
      "input:focus ~ &, input:focus:not(checked) ~ &": {
        borderColor: "currentcolor"
      },
      "input:focus ~ &::before, input:focus:not(checked) ~ &::before": {
        boxShadow: "focusOutline"
      },
      "input:disabled ~ &": {
        color: "interactive.border.disabled",
        pointerEvents: "none"
      },
      "input:checked ~ &": {
        backgroundColor: "currentcolor"
      },
      "input:checked ~ &:after": {
        backgroundColor: "white",
        width: "half",
        height: "half"
      },
      "input:disabled ~ &, input:checked:disabled ~ &": {
        backgroundColor: "interactive.background.disabled"
      },
      "input:disabled:hover ~ &, input:checked:disabled:hover ~ &": {
        backgroundColor: "interactive.background.disabled",
        color: "interactive.border.disabled"
      },
      "input:checked:disabled ~ &:after": {
        backgroundColor: "interactive.icon.disabled"
      }
    })
  })
);
var Radio = forwardRef24(function Radio2(_a, ref) {
  var _b = _a, { checked, error, defaultChecked } = _b, props = __objRest(_b, ["checked", "error", "defaultChecked"]);
  const propsForRadioInput = __spreadValues(__spreadValues({}, pickInputProps(props)), pickGlobalHTMLProps(props));
  const propsForInputContainer = pickLayoutProps(props);
  const styleProps2 = pickStyleProps(props);
  const propsForInputIcon = omitLayoutProps(styleProps2);
  return /* @__PURE__ */ jsxs4(Box, __spreadProps(__spreadValues({}, propsForInputContainer), { children: [
    /* @__PURE__ */ jsx27(
      Box,
      __spreadValues({
        as: "input",
        ref,
        type: "radio",
        checked,
        defaultChecked,
        css: css_default(visuallyHiddenInputStyles),
        "data-testid": "genesis-radio-input"
      }, propsForRadioInput)
    ),
    /* @__PURE__ */ jsx27(
      RadioIcon,
      __spreadValues(__spreadProps(__spreadValues({
        "aria-hidden": "true",
        color: "interactive.border.default"
      }, Boolean(error) && {
        color: "interactive.border.critical.default"
      }), {
        "data-testid": "genesis-radio-icon",
        transitionDuration: "base"
      }), propsForInputIcon)
    )
  ] }));
});
Radio.displayName = "Radio";

// src/Input/Textarea/Textarea.tsx
import { forwardRef as forwardRef25 } from "react";
import { jsx as jsx28 } from "@emotion/core/jsx-runtime";
var Textarea = forwardRef25(
  (_a, ref) => {
    var _b = _a, { rows, cols, resize = "both", wrap = "soft" } = _b, props = __objRest(_b, ["rows", "cols", "resize", "wrap"]);
    const { lineHeights, space: space2, borderWidths } = useTheme();
    const defaultHeight = parseInt(lineHeights.body1, 10) * 3 + // Show 3 lines by default
    space2.threeQuarters * 2 + // Add top and bottom padding b/c of box-sizing: border-box
    borderWidths.thin * 2;
    return /* @__PURE__ */ jsx28(
      TextInputBase,
      __spreadValues({
        as: "textarea",
        ref,
        rows,
        cols,
        height: !rows ? defaultHeight : void 0,
        width: !cols ? "100%" : void 0,
        wrap,
        minHeight: "three",
        overflowX: wrap === "off" ? "auto" : "hidden",
        overflowY: "auto",
        css: css_default({ resize })
      }, props)
    );
  }
);
Textarea.displayName = "Textarea";

// src/TextField/Hint/Hint.tsx
import { forwardRef as forwardRef26 } from "react";
import { jsx as jsx29 } from "@emotion/core/jsx-runtime";
var Hint = forwardRef26(
  (props, ref) => /* @__PURE__ */ jsx29(
    Text,
    __spreadValues({
      color: "onSurface.text.subdued",
      fontSize: "body2",
      fontWeight: "regular",
      ref
    }, props)
  )
);
Hint.displayName = "Hint";

// src/TextField/TextField.tsx
import { jsx as jsx30, jsxs as jsxs5 } from "@emotion/core/jsx-runtime";
var TextField = (props) => {
  const inputProps = pickInputProps(props);
  const wrapperProps = pickStyleProps(props);
  const globalHTMLProps = pickGlobalHTMLProps(props);
  const { label, hint, error, name, id: inputIdProp } = props;
  const inputId = inputIdProp || `${name}-Input`;
  const hintId = hint ? `${name}-Hint` : void 0;
  const errorMessageId = error ? `${name}-ErrorMessage` : void 0;
  const ariaDescribedby = error && hint ? `${errorMessageId} ${hintId}` : hintId || errorMessageId;
  return /* @__PURE__ */ jsxs5(Box, __spreadProps(__spreadValues({}, wrapperProps), { children: [
    /* @__PURE__ */ jsxs5(Box, { marginBottom: "quarter", children: [
      /* @__PURE__ */ jsx30(Label, { htmlFor: inputId, children: /* @__PURE__ */ jsx30(LabelText, { children: label }) }),
      hint && /* @__PURE__ */ jsx30(Hint, { id: hintId, children: hint })
    ] }),
    /* @__PURE__ */ jsx30(
      TextInput,
      __spreadProps(__spreadValues(__spreadValues({
        name,
        error,
        "aria-describedby": ariaDescribedby
      }, inputProps), globalHTMLProps), {
        id: inputId
      })
    ),
    error && /* @__PURE__ */ jsx30(ErrorMessage, { id: errorMessageId, marginTop: "quarter", children: error })
  ] }));
};

// src/Button/PrimaryButton/PrimaryButton.tsx
import { forwardRef as forwardRef28 } from "react";

// src/Button/BaseButton/BaseButton.tsx
import { forwardRef as forwardRef27 } from "react";
import { jsx as jsx31 } from "@emotion/core/jsx-runtime";
var BaseButton = forwardRef27(
  (_a, ref) => {
    var _b = _a, {
      tabIndex = 0,
      paddingY = "threeQuarters",
      borderWidth = "thin",
      isLoading = false,
      children,
      disabled: disabled2,
      as = "button"
    } = _b, props = __objRest(_b, [
      "tabIndex",
      "paddingY",
      "borderWidth",
      "isLoading",
      "children",
      "disabled",
      "as"
    ]);
    const theme = useTheme();
    const borderWidthValue = theme.borderWidths[borderWidth];
    let paddingYValue = paddingY;
    if (typeof paddingY === "string") {
      const py = theme.space[paddingY];
      const bw = typeof borderWidth === "string" ? borderWidthValue : 0;
      paddingYValue = py - bw;
    }
    const focusOutlineOffset = `-${borderWidthValue + 2}px`;
    return /* @__PURE__ */ jsx31(
      Flex,
      __spreadProps(__spreadValues({
        as,
        display: "inline-flex",
        alignItems: "center",
        backgroundColor: "tertiary.background.default",
        borderColor: "transparent",
        borderRadius: "button",
        borderStyle: "solid",
        borderWidth,
        fontSize: "body1",
        fontWeight: "medium",
        justifyContent: "center",
        paddingX: "two",
        tabIndex,
        ref,
        disabled: trueOrUndefined(disabled2 || isLoading),
        css: css_default({
          paddingY: paddingYValue,
          position: props.position || "relative",
          "::before": {
            content: '""',
            position: "absolute",
            top: focusOutlineOffset,
            insetInlineStart: focusOutlineOffset,
            insetInlineEnd: focusOutlineOffset,
            bottom: focusOutlineOffset,
            borderRadius: props.borderRadius || "button"
          },
          ":hover": {
            cursor: "pointer",
            borderColor: "transparent"
          },
          ":focus": {
            outline: 0
          },
          ":focus::before": {
            boxShadow: "focusOutline"
          },
          ":disabled,:disabled:hover": __spreadValues({
            cursor: "not-allowed",
            ":active": {
              boxShadow: "none"
            }
          }, isLoading ? {} : {
            backgroundColor: "interactive.background.disabled",
            borderColor: "interactive.border.disabled",
            color: "interactive.action.subdued"
          })
        })
      }, props), {
        children: /* @__PURE__ */ jsx31(Spinner, { isLoading, children })
      })
    );
  }
);
BaseButton.displayName = "BaseButton";

// src/Button/PrimaryButton/PrimaryButton.tsx
import { jsx as jsx32 } from "@emotion/core/jsx-runtime";
var PrimaryButton = forwardRef28(
  (props, ref) => /* @__PURE__ */ jsx32(
    BaseButton,
    __spreadValues({
      backgroundColor: "primary.background.default",
      color: "primary.text.default",
      ref,
      css: css_default({
        ":hover": {
          backgroundColor: "primary.background.hovered"
        },
        ":active": {
          backgroundColor: "primary.background.pressed"
        }
      })
    }, props)
  )
);
PrimaryButton.displayName = "PrimaryButton";

// src/Button/SecondaryButton/SecondaryButton.tsx
import { forwardRef as forwardRef29 } from "react";
import { jsx as jsx33 } from "@emotion/core/jsx-runtime";
var SecondaryButton = forwardRef29(
  (props, ref) => /* @__PURE__ */ jsx33(
    BaseButton,
    __spreadValues({
      backgroundColor: "secondary.background.default",
      color: "secondary.text.default",
      borderColor: "secondary.border.default",
      borderWidth: "thick",
      ref,
      css: css_default({
        ":hover": {
          color: "secondary.text.hovered",
          backgroundColor: "secondary.background.hovered"
        },
        ":active": {
          color: "secondary.text.hovered",
          backgroundColor: "secondary.background.pressed"
        }
      })
    }, props)
  )
);
SecondaryButton.displayName = "SecondaryButton";

// src/Button/DangerButton/DangerButton.tsx
import { forwardRef as forwardRef30 } from "react";
import { jsx as jsx34 } from "@emotion/core/jsx-runtime";
var DangerButton = forwardRef30(
  (props, ref) => /* @__PURE__ */ jsx34(
    BaseButton,
    __spreadValues({
      backgroundColor: "primary.background.critical.default",
      color: "primary.text.critical.default",
      ref,
      css: css_default({
        ":hover": {
          backgroundColor: "primary.background.critical.hovered"
        },
        ":active": {
          backgroundColor: "primary.background.critical.pressed"
        },
        ":focus": {
          backgroundColor: "primary.background.critical.hovered"
        }
      })
    }, props)
  )
);
DangerButton.displayName = "DangerButton";

// src/Button/SubtleButton/SubtleButton.tsx
import { forwardRef as forwardRef31 } from "react";
import { jsx as jsx35 } from "@emotion/core/jsx-runtime";
var SubtleButton = forwardRef31(
  (props, ref) => /* @__PURE__ */ jsx35(
    BaseButton,
    __spreadValues({
      borderColor: "tertiary.border.default",
      borderWidth: "thick",
      color: "tertiary.text.default",
      ref,
      css: css_default({
        ":hover": {
          backgroundColor: "tertiary.background.hovered",
          color: "tertiary.text.hovered"
        },
        ":active": {
          backgroundColor: "tertiary.background.pressed",
          color: "tertiary.text.hovered"
        }
      })
    }, props)
  )
);
SubtleButton.displayName = "SubtleButton";

// src/Button/QuietButton/QuietButton.tsx
import { forwardRef as forwardRef32 } from "react";
import { jsx as jsx36 } from "@emotion/core/jsx-runtime";
var QuietButton = forwardRef32(
  (props, ref) => /* @__PURE__ */ jsx36(
    BaseButton,
    __spreadValues({
      color: "tertiary.text.default",
      ref,
      css: css_default({
        ":hover": {
          backgroundColor: "tertiary.background.hovered",
          color: "tertiary.text.hovered"
        },
        ":active": {
          backgroundColor: "tertiary.background.pressed",
          color: "tertiary.text.hovered"
        }
      })
    }, props)
  )
);
QuietButton.displayName = "QuietButton";

// src/Button/Link/Link.tsx
import { forwardRef as forwardRef33 } from "react";
import { jsx as jsx37 } from "@emotion/core/jsx-runtime";
var Link = forwardRef33(
  (_a, ref) => {
    var _b = _a, { tabIndex = 0, disabled: disabled2, href, children } = _b, props = __objRest(_b, ["tabIndex", "disabled", "href", "children"]);
    const hrefElement = disabled2 ? null : href;
    return /* @__PURE__ */ jsx37(
      Box,
      __spreadProps(__spreadValues({
        as: "a",
        href: hrefElement,
        tabIndex,
        borderRadius: "small",
        color: "interactive.action.primary",
        fontSize: "body1",
        fontWeight: "medium",
        display: "inline-block",
        ref,
        css: css_default(__spreadValues({
          textDecoration: "none",
          position: "relative",
          "::before": {
            content: '""',
            position: "absolute",
            top: "-2px",
            insetInlineStart: "-2px",
            insetInlineEnd: "-2px",
            bottom: "-2px",
            borderRadius: props.borderRadius || "small"
          },
          ":hover": {
            cursor: "pointer",
            textDecoration: "underline"
          },
          ":focus": {
            outline: 0,
            borderWidth: "thin",
            borderColor: "interactive.focus.outer"
          },
          ":focus::before": {
            boxShadow: "focusOutline"
          }
        }, disabled2 && {
          "&:hover": {
            cursor: "not-allowed",
            textDecoration: "none"
          },
          color: "interactive.action.disabled"
        }))
      }, props), {
        children
      })
    );
  }
);
Link.displayName = "Link";

// src/Button/SubtleLink/SubtleLink.tsx
import { forwardRef as forwardRef34 } from "react";
import { jsx as jsx38 } from "@emotion/core/jsx-runtime";
var SubtleLink = forwardRef34(
  (_a, ref) => {
    var _b = _a, { tabIndex = 0, children } = _b, props = __objRest(_b, ["tabIndex", "children"]);
    return /* @__PURE__ */ jsx38(
      Box,
      __spreadProps(__spreadValues({
        as: "a",
        tabIndex,
        color: "inherit",
        borderRadius: "small",
        ref,
        hoverStyle: {
          color: "interactive.action.hovered"
        },
        focusStyle: {
          outline: 0,
          boxShadow: "focusRing"
        }
      }, props), {
        children
      })
    );
  }
);
SubtleLink.displayName = "SubtleLink";

// src/Image/Image.tsx
import { forwardRef as forwardRef35 } from "react";
import { jsx as jsx39 } from "@emotion/core/jsx-runtime";
var Image = forwardRef35(
  (_a, ref) => {
    var _b = _a, {
      alt,
      width,
      height,
      size,
      display = "inline-block",
      role
    } = _b, props = __objRest(_b, [
      "alt",
      "width",
      "height",
      "size",
      "display",
      "role"
    ]);
    return /* @__PURE__ */ jsx39(
      Box,
      __spreadValues({
        loading: "lazy",
        as: "img",
        alt: role === "presentation" ? "" : alt,
        display,
        css: css_default({
          width: width || size || height && "auto" || "100%",
          height: height || size || "auto"
        }),
        ref
      }, props)
    );
  }
);
Image.displayName = "Image";

// src/BackgroundImage/BackgroundImage.tsx
import { forwardRef as forwardRef36 } from "react";
import { jsx as jsx40 } from "@emotion/core/jsx-runtime";
var BackgroundImage = forwardRef36(
  (_a, ref) => {
    var _b = _a, {
      src,
      alt,
      size,
      width,
      height,
      backgroundSize = "cover",
      backgroundRepeat = "no-repeat",
      backgroundPosition = "50%"
    } = _b, props = __objRest(_b, [
      "src",
      "alt",
      "size",
      "width",
      "height",
      "backgroundSize",
      "backgroundRepeat",
      "backgroundPosition"
    ]);
    return /* @__PURE__ */ jsx40(
      Box,
      __spreadValues(__spreadValues({
        ref,
        backgroundImage: `url(${src})`,
        backgroundSize,
        backgroundRepeat,
        backgroundPosition,
        width: width || size || "100%",
        height: height || size
      }, alt ? {
        "aria-label": alt,
        role: alt === "" ? "decorative" : "img"
      } : null), props)
    );
  }
);
BackgroundImage.displayName = "BackgroundImage";

// src/CoverImage/CoverImage.tsx
import { forwardRef as forwardRef37 } from "react";
import { jsx as jsx41 } from "@emotion/core/jsx-runtime";
var CoverImage = forwardRef37(
  (props, ref) => /* @__PURE__ */ jsx41(BackgroundImage, __spreadValues({ display: "inline-block", ref }, props))
);
CoverImage.displayName = "CoverImage";

// src/Storybook/Code.tsx
import { jsx as jsx42 } from "@emotion/core/jsx-runtime";
var Code = (props) => /* @__PURE__ */ jsx42(
  Text,
  __spreadValues({
    as: "code",
    color: "decorative.brand.primary.default",
    fontSize: "inherit",
    lineHeight: "inherit",
    css: { fontFamily: "monospace" }
  }, props)
);

// src/Storybook/Note.tsx
import { jsx as jsx43 } from "@emotion/core/jsx-runtime";
var Note = (props) => /* @__PURE__ */ jsx43(
  Caption,
  __spreadValues({
    color: "onSurface.text.subdued",
    backgroundColor: "surface.background.secondary",
    borderRadius: "medium",
    padding: "half"
  }, props)
);

// src/Storybook/SwitchToDocs.tsx
import { jsx as jsx44, jsxs as jsxs6 } from "@emotion/core/jsx-runtime";
var SwitchToDocs = () => {
  const { search } = window.top.location;
  const storyTabRegex = /^\?path=\/story/;
  const isStoryTab = storyTabRegex.test(search);
  if (isStoryTab) {
    const docsURL = `/${search.replace(storyTabRegex, "?path=/docs")}`;
    window.top.location.replace(docsURL);
    return /* @__PURE__ */ jsxs6(Note, { marginBottom: "oneAndHalf", children: [
      /* @__PURE__ */ jsx44(Link, { fontSize: "inherit", href: docsURL, children: "Please switch to Docs tab" }),
      " ",
      "to view documentation. You should be redirected automatically."
    ] });
  }
  return null;
};
export {
  BackgroundImage,
  Base,
  BodyOne,
  BodyOneSecondary,
  BodyTwo,
  BodyTwoSecondary,
  Box,
  Caption,
  Checkbox,
  ChoiceText,
  Code,
  CoverImage,
  DangerButton,
  ErrorMessage,
  Flex,
  FlexBase,
  GLOBAL_TOKENS,
  GenesisThemeProvider,
  HeadingFour,
  HeadingOne,
  HeadingThree,
  HeadingTwo,
  Image,
  Label,
  LabelText,
  Link,
  Note,
  Overline,
  PrimaryButton,
  QuietButton,
  Radio,
  SecondaryButton,
  Spinner,
  SubtitleOne,
  SubtitleTwo,
  SubtleButton,
  SubtleLink,
  SwitchToDocs,
  Text,
  TextBase,
  TextField,
  TextInput,
  Textarea,
  VisuallyHidden,
  borderValue,
  commonsArchetypeLightTheme,
  css_default as css,
  formatThemeForCommons,
  default2 as genesisStyled,
  omitInputProps,
  omitLayoutProps,
  omitStyleProps,
  pickGlobalHTMLProps,
  pickInputProps,
  pickLayoutProps,
  pickStyleProps,
  themeWithGlobalTokens,
  trueOrUndefined,
  useTheme,
  visuallyHidden,
  visuallyHiddenInputStyles
};


  if (typeof window !== 'undefined' && !(typeof process !== 'undefined' && process.env?.NODE_ENV === 'test')) {
    window.leagueSDKsPresent = window.leagueSDKsPresent || [];
    window.leagueSDKsPresent['@leagueplatform/genesis-commons'] = window.leagueSDKsPresent['@leagueplatform/genesis-commons'] || [];
    window.leagueSDKsPresent['@leagueplatform/genesis-commons'].push('2.23.5');

    const numInstances = window.leagueSDKsPresent['@leagueplatform/genesis-commons'].length

    if (numInstances > 1) {
      console.error('Multiple copies (' + numInstances + ') of the @leagueplatform/genesis-commons module are loaded! This can cause issues. Ensure that your project bundle only contains one copy/version of each League SDK package.');
    }
  }
  
//# sourceMappingURL=index.js.map